type DefaultAdImageKey = "male" | "female" | "neutral";

type AdImageLike = {
  imageUrl?: string | null;
  isDefault?: boolean | null;
  isPrimary?: boolean | null;
};

type AdLike = {
  images?: AdImageLike[] | null;
  gender?: string | null;
  owner?: {
    gender?: string | null;
  } | null;
  userGender?: string | null;
};

export const DEFAULT_AD_IMAGES: Record<DefaultAdImageKey, string> = {
  male: "https://shreeksakn.b-cdn.net/male.png",
  female: "https://shreeksakn.b-cdn.net/female.png",
  // TODO: Replace with a dedicated neutral CDN image when one is available.
  neutral: "https://shreeksakn.b-cdn.net/male.png",
};

export function normalizeAdGender(gender?: string | null): DefaultAdImageKey {
  const value = gender?.trim().toLowerCase();

  if (value === "male" || value === "m" || value === "man") return "male";
  if (value === "female" || value === "f" || value === "woman") return "female";

  return "neutral";
}

export function getDefaultAdImageByGender(gender?: string | null): string {
  return DEFAULT_AD_IMAGES[normalizeAdGender(gender)];
}

export function getUploadedAdImageUrl(
  images?: AdImageLike[] | null,
): string | null {
  if (!Array.isArray(images) || images.length === 0) {
    return null;
  }

  const selected =
    images.find((img) => (img.isPrimary || img.isDefault) && img.imageUrl?.trim()) ??
    images.find((img) => img.imageUrl?.trim());

  return selected?.imageUrl?.trim() || null;
}

export function getAdGender(ad?: AdLike | null): string | null {
  return ad?.gender ?? ad?.owner?.gender ?? ad?.userGender ?? null;
}

export function getAdImageOrDefault(ad?: AdLike | null): string {
  return getUploadedAdImageUrl(ad?.images) ?? getDefaultAdImageByGender(getAdGender(ad));
}
